module.exports = __webpack_public_path__ + "img/ic_share_background.d31cdafd.png";